import ApiMsApproveRequestMaterialsService from '@/services/ms_approve_request_materials'

export const state = {
  quotes: {
    total_items: 0,
    total_pages: 1,
    items: []
  },
  listEmployeesToAssignRequestQuote: {
    count: 0,
    employees: [],
    pages: 1
  }
}

export const getters = {
  quotes: (state) => state.quotes,
  listEmployeesToAssignRequestQuote: (state) => state.listEmployeesToAssignRequestQuote
}

export const mutations = {
  SET_QUOTES(state, payload) {
    state.quotes = payload
    state.quotes.items = state.quotes.items.map(item => {
      return {
        ...item,
        assigned_user: item.assigned_users.length ? item.assigned_users[0].user.id : null,
        items: [
          {
            id: item.id,
            title: item.title,
            name: item.description,
            documents: item.documents,
            comments: item.comments,
            status: item.status,
            created_by: item.created_by,
          }
        ]
      }
    })
  },
  SET_QUOTE(state, payload) {
    let indexQuote = state.quotes.items.findIndex(item => item.id === payload.id)
    if (indexQuote !== -1) {
      state.quotes.items[indexQuote] = {
        ...payload,
        assigned_user: payload.assigned_users.length ? payload.assigned_users[0].user.id : null,
        items: [
          {
            id: payload.id,
            title: payload.title,
            name: payload.description,
            documents: payload.documents,
            comments: payload.comments,
            status: payload.status,
            created_by: payload.created_by,
          }
        ]
      }
      state.quotes.items = [...state.quotes.items]
    }
  },
  SPLICE_COMMENT_REQUEST_DELETED(state, payload) {
    let requestIndex = state.quotes.items.findIndex(item => item.id === payload.request_id)
    state.quotes.items[requestIndex].comments = state.quotes.items[requestIndex].comments.filter(item => {
      return item.id !== payload.comment_id
    })
  },
  SET_LIST_EMPLOYEES_TO_ASSIGN_REQUEST_QUOTE(state, payload) {
    state.listEmployeesToAssignRequestQuote = payload
  }
}

export const actions = {
  //Request Endpoints
  async getQuotes({ commit }, payload) {
    try {
      const resp = (await ApiMsApproveRequestMaterialsService.get(`/api/quotation/get_quotation`, payload)).data
      commit('SET_QUOTES', resp)
      return resp
    } catch (error) {
      return error
    }
  },
  async getQuoteById({ commit }, payload) {
    let queryParams = new URLSearchParams({ ...payload })
    try {
      const resp = await ApiMsApproveRequestMaterialsService.get(`/api/quotation/get_quotation_by_id?${queryParams}`, payload)
      commit('SET_QUOTE', resp.data)
      return resp
    } catch (error) {
      return error
    }
  },
  async createRequestQuote({ _ }, payload) {
    let payloadRequestService = new FormData()
    payloadRequestService.append('body', JSON.stringify(payload.body))
    for (let i = 0; i < payload.files.length; i++) {
      payloadRequestService.append(`files`, payload.files[i])
    }
    try {
      const resp = await ApiMsApproveRequestMaterialsService.post(
        '/api/post_quotation', payloadRequestService)
      return resp
    } catch (error) {
      return error.response
    }
  },
  async finishRequestQuote({ commit }, payload) {
    let queryParams = new URLSearchParams({ ...payload })
    try {
      const resp = await ApiMsApproveRequestMaterialsService.put(`/api/quotation/finish_quotation?${queryParams}`, payload)
      return resp
    } catch (error) {
      return error
    }
  },
  async updateRequestQuoteToValidationUser({ commit }, payload) {
    let queryParams = new URLSearchParams({ ...payload })
    try {
      const resp = await ApiMsApproveRequestMaterialsService.put(`/api/quotation/abastecimiento_approval?${queryParams}`, payload)
      return resp
    } catch (error) {
      return error
    }
  },
  async updateRequestQuoteToReviewUser({ commit }, payload) {
    let queryParams = new URLSearchParams({ ...payload })
    try {
      const resp = await ApiMsApproveRequestMaterialsService.put(`/api/quotation/abastecimiento_to_user?${queryParams}`, payload)
      return resp
    } catch (error) {
      return error
    }
  },
  async updateRequestQuoteToQuotationFromUser({ commit }, payload) {
    let queryParams = new URLSearchParams({ ...payload })
    try {
      const resp = await ApiMsApproveRequestMaterialsService.put(`/api/quotation/user_to_abastecimiento?${queryParams}`, payload)
      return resp
    } catch (error) {
      return error
    }
  },
  async updateRequestQuoteToRejection({ commit }, payload) {
    let queryParams = new URLSearchParams({ ...payload })
    try {
      const resp = await ApiMsApproveRequestMaterialsService.put(`/api/quotation/reject_quotation?${queryParams}`, payload)
      return resp
    } catch (error) {
      return error
    }
  },
  async updateRequestQuoteToCancelFromUser({ commit }, payload) {
    let queryParams = new URLSearchParams({ ...payload })
    try {
      const resp = await ApiMsApproveRequestMaterialsService.put(`/api/quotation/cancel_quotation?${queryParams}`, payload)
      return resp
    } catch (error) {
      return error
    }
  },

  //Services Endpoints
  async updateService({ commit }, payload) {
    try {
      let payloadUpdateFiles = new FormData()
      payloadUpdateFiles.append('body', JSON.stringify({
        quotation_id: payload.quotation_id,
        title: payload.title,
        description: payload.description,
        user: payload.user,
        documents: payload.documents
      }))
      if (payload.files) {
        for (let i = 0; i < payload.files.length; i++) {
          payloadUpdateFiles.append(`files`, payload.files[i])
        }
      }
      const resp = await ApiMsApproveRequestMaterialsService.put(
        `api/quotation/update_quotation`,
        payloadUpdateFiles
      )
      return resp
    } catch (error) {
      return error.response
    }
  },
  async updateStatusServiceToApproveFromUser({ commit }, payload) {
    let queryParams = new URLSearchParams({ ...payload })
    try {
      const resp = await ApiMsApproveRequestMaterialsService.put(`/service_request/quotes/update_status_service_to_approve_from_user?${queryParams}`, payload)
      return resp
    } catch (error) {
      return error
    }
  },
  async updateStatusServiceToReviewUser({ commit }, payload) {
    let queryParams = new URLSearchParams({ ...payload })
    try {
      const resp = await ApiMsApproveRequestMaterialsService.put(`/service_request/quotes/update_status_service_to_review_user?${queryParams}`, payload)
      return resp
    } catch (error) {
      return error
    }
  },
  async updateStatusServiceToQuotation({ commit }, payload) {
    let queryParams = new URLSearchParams({ ...payload })
    try {
      const resp = await ApiMsApproveRequestMaterialsService.put(`/service_request/quotes/update_status_service_to_quotation?${queryParams}`, payload)
      return resp
    } catch (error) {
      return error
    }
  },
  async createCommentQuote({ commit }, payload) {
    let queryParams = new URLSearchParams({
      comment: payload.comment,
      quotation_id: payload.quotation_id,
      user: payload.user
    })
    try {
      const resp = await ApiMsApproveRequestMaterialsService.post(
        `/api/quotation/add_comment_quotation?${queryParams}`, payload)
      return resp
    } catch (error) {
      return error.response
    }
  },
  async deleteCommentQuote({ commit }, payload) {
    let queryParams = new URLSearchParams({
      comment_id: payload.comment_id,
      user: payload.user
    })
    try {
      const resp = await ApiMsApproveRequestMaterialsService.put(
        `/api/quotation/delete_comment_quotation?${queryParams}`, payload)
      commit('SPLICE_COMMENT_REQUEST_DELETED', payload)
      return resp
    } catch (error) {
      console.log(error)
      return error.response
    }
  },
  async getListEmployeesToAssignRequestQuote({ commit }, payload) {
    try {
      const resp = (
        await ApiMsApproveRequestMaterialsService.get(`/api/mantainers/employees`, payload)
      ).data
      commit('SET_LIST_EMPLOYEES_TO_ASSIGN_REQUEST_QUOTE', resp)
      return resp
    } catch (error) {
      return error
    }
  },
  async assignUserToRequestQuote({ commit }, payload) {
    try {
      const resp = await ApiMsApproveRequestMaterialsService.post(
        `/api/quotation/link_quotation_approver?user=${payload.user}&quotation_id=${payload.quotation_id}&approver_id=${payload.approver_id}`,
        payload
      )
      return resp
    } catch (error) {
      return error
    }
  },
  async unassignUserToRequestQuote({ commit }, payload) {
    try {
      const resp = await ApiMsApproveRequestMaterialsService.post(
        `/api/quotation/unlink_quotation_approver?user=${payload.user}&quotation_id=${payload.quotation_id}&approver_id=${payload.approver_id}`,
        payload
      )
      return resp
    } catch (error) {
      return error
    }
  },
}
